module.exports = __webpack_public_path__ + "img/8.328cccd2.jpg";